import type { UseFormRegister, FieldErrors } from 'react-hook-form';

export interface ReviewFormValues {
  emitenteNome: string;
  emitenteCnpj: string;
  valorTotal: string;
  dataEmissao: string;
  categoria: string;
  formaPagamento: string;
}

export const CATEGORIAS = [
  'Combustível', 'Material de consumo', 'Serviços gerais', 'Água e esgoto',
  'Energia elétrica', 'Telefone / Internet', 'Alimentação', 'Transporte',
  'Manutenção', 'Movimentação bancária', 'Outros',
];

export const FORMAS_PAGAMENTO = [
  'PIX', 'Transferência', 'Boleto bancário', 'Cartão corporativo', 'Dinheiro', 'Cheque',
];

interface OCRReviewFormProps {
  register: UseFormRegister<ReviewFormValues>;
  errors: FieldErrors<ReviewFormValues>;
}

/** Campos editáveis do formulário de revisão OCR. */
export function OCRReviewForm({ register, errors }: OCRReviewFormProps) {
  return (
    <form
      id="ocr-review-form"
      noValidate
      style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
    >
      <FieldRow label="Fornecedor" error={errors.emitenteNome?.message}>
        <input {...register('emitenteNome')} aria-label="Nome do fornecedor" placeholder="Nome do fornecedor" style={inputStyle} />
      </FieldRow>
      <FieldRow label="CNPJ" error={errors.emitenteCnpj?.message}>
        <input {...register('emitenteCnpj')} aria-label="CNPJ do fornecedor" placeholder="00.000.000/0000-00" style={inputStyle} />
      </FieldRow>
      <FieldRow label="Valor (R$)" error={errors.valorTotal?.message}>
        <input
          {...register('valorTotal')}
          aria-label="Valor total do documento"
          placeholder="0,00"
          inputMode="decimal"
          style={{ ...inputStyle, fontFamily: 'var(--font-mono)', fontWeight: 600 }}
        />
      </FieldRow>
      <FieldRow label="Data emissão" error={errors.dataEmissao?.message}>
        <input {...register('dataEmissao')} aria-label="Data de emissão" type="date" style={inputStyle} />
      </FieldRow>
      <FieldRow label="Categoria" error={errors.categoria?.message}>
        <select {...register('categoria')} aria-label="Categoria da despesa" style={inputStyle}>
          {CATEGORIAS.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </FieldRow>
      <FieldRow label="Forma de pagamento" error={errors.formaPagamento?.message}>
        <select {...register('formaPagamento')} aria-label="Forma de pagamento" style={inputStyle}>
          {FORMAS_PAGAMENTO.map((f) => <option key={f} value={f}>{f}</option>)}
        </select>
      </FieldRow>
    </form>
  );
}

function FieldRow({ label, error, children }: { label: string; error?: string; children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--fg-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        {label}
      </label>
      {children}
      {error && (
        <span role="alert" style={{ fontSize: 11, color: 'var(--block)', marginTop: 2 }}>{error}</span>
      )}
    </div>
  );
}

export const inputStyle: React.CSSProperties = {
  width: '100%',
  height: 42,
  padding: '0 12px',
  borderRadius: 'var(--r-2)',
  border: '1px solid var(--card-stroke)',
  background: 'var(--card-soft)',
  color: 'var(--fg)',
  fontSize: 14,
  fontFamily: 'inherit',
  outline: 'none',
  boxSizing: 'border-box',
};
